import { render } from "./SelectManagerComponent.vue?vue&type=template&id=513cb5b0&ts=true"
import script from "./SelectManagerComponent.vue?vue&type=script&lang=ts"
export * from "./SelectManagerComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__